// Brand ambience from the landing: film grain + cold cursor light.
import { useEffect, useRef } from 'react';
import { reduceMotion } from '@/lib/random';

const GRAIN = "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='120' height='120'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")";

export const Grain = () => <div className="grain" aria-hidden="true" style={{ backgroundImage: GRAIN }} />;

export function CursorGlow() {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const el = ref.current;
    if (!el || reduceMotion() || window.matchMedia('(hover: none)').matches) return;
    let tx = window.innerWidth / 2, ty = window.innerHeight / 2, cx = tx, cy = ty, active = false, raf = 0;
    const move = (e: MouseEvent) => { tx = e.clientX; ty = e.clientY; if (!active) { active = true; el.classList.add('visible'); } };
    const leave = () => el.classList.remove('visible');
    const loop = () => {
      cx += (tx - cx) * 0.2; cy += (ty - cy) * 0.2;
      el.style.transform = `translate3d(${(cx - 110).toFixed(1)}px, ${(cy - 110).toFixed(1)}px, 0)`;
      raf = requestAnimationFrame(loop);
    };
    window.addEventListener('mousemove', move, { passive: true });
    window.addEventListener('mouseleave', leave);
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); window.removeEventListener('mousemove', move); window.removeEventListener('mouseleave', leave); };
  }, []);
  return <div className="cursor-glow" ref={ref} aria-hidden="true" />;
}
